"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Issue w/ live vs final
Attempt is used 2 different ways

Final
{
  att: "FOUL",
  nu: 1,
  co: null,
  w: "",
  im: 0,
  fiav: "6346088699112",
  fv: {
    i: "6346088699112",
    att: 0,
    vdr: "0:12",
    vpi: "https://cf-images.us-east-1.prod.boltdns.net/v1/jit/6055873638001/19a67d10-cff6-445c-a64f-6da050aad1f3/main/1280x720/6s455ms/match/image.jpg",
    vti: "https://cf-images.us-east-1.prod.boltdns.net/v1/jit/6055873638001/19a67d10-cff6-445c-a64f-6da050aad1f3/main/160x90/6s455ms/match/image.jpg"
  }
}

Live
{
  att: "1",
  cc: "",
  co: "16-09.25",
  fiav: "6346090001112",
  fv: {
    i: "6346090001112",
    vpi: "https://cf-images.us-east-1.prod.boltdns.net/v1/jit/6055873638001/860cef5b-e3e3-42e9-a645-d3c1f4608587/main/1280x720/6s60ms/match/image.jpg",
    vti: "https://cf-images.us-east-1.prod.boltdns.net/v1/jit/6055873638001/860cef5b-e3e3-42e9-a645-d3c1f4608587/main/160x90/6s60ms/match/image.jpg"
  },
  im: "5112000",
  m: "5.11",
  p: "",
  pc: "",
  w: ""
}
 */